import { IQuery } from 'core-ts-types';
import { ORM } from 'utility-ts-orm';
import { IPollAnswerBuilderDTD, PollAnswerDataStore } from '../datastore/poll_answer_datastore';
import { IPollDataStoreDTD, PollDataStore } from '../datastore/poll_datastore';
import { IChoiceBuilderDTD } from '../poll_interfaces';
import { PollStudentDataStore } from './../datastore/poll_student_datastore';
import { IBuiltPoll, IPollWithAnswers, PollResultsServant } from './../servants/poll_results_servant';

export interface IPollQueryChoice extends IPollAnswerBuilderDTD {
  answered?: IChoiceBuilderDTD | boolean;
  nk?: string;
}

export class PollQueryModel {
  private _result: IBuiltPoll;
  private _isNewPoll: boolean;

  constructor(
    private ngPollAnswerDataStore: PollAnswerDataStore,
    private ngPollDataStore: PollDataStore,
    private ngPollStudentDataStore: PollStudentDataStore,
    private ngPollResultsServant: PollResultsServant
  ) {
    ORM.registerQuery(this, ngPollDataStore, ngPollAnswerDataStore, ngPollStudentDataStore);
  }

  getQuestionById(questionId: number): object {
    return this._result.question[questionId];
  }

  run(): IQuery {
    this.result = this.ngPollResultsServant.buildPoll(
      this.ngPollDataStore.read(),
      this.ngPollAnswerDataStore.read(),
      this.ngPollStudentDataStore.read()
    );

    // TODO: remove next line
    // send a message to the native header so it can know the dynamic
    // title of the poll.
    // @deprecate 12/1/2024 - poll will be re-written in native
    //
    window['ess'].send({
      site: 'native',
      source: 'header',
      status: 'success',
      action: 'update-content',
      data: {
        title: this.result.poll.name
      }
    });

    return this;
  }

  markPollAsFinished(): void {
    this._result.is_completed = true;
  }

  get isUpdatedPoll(): boolean {
    return this._isNewPoll;
  }

  set isUpdatedPoll(bool: boolean) {
    this._isNewPoll = bool;
  }

  get result(): IBuiltPoll {
    return this._result;
  }

  set result(result: IBuiltPoll) {
    this._result = result;
  }

  get isOptional(): boolean {
    return !this._result.poll.mandatory;
  }

  get isMandatory(): boolean {
    return this._result.poll.mandatory;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/queries/poll_query_model.ts